import axios from "axios";

export const state = {
    financialyears: [],
};

export const getters = {
    financialyears: state => state.financialyears,
};

export const mutations = {
    setYears(financialyears, newValue) {
        state.financialyears = newValue
    },
};

export const actions = {
    async fetchFinancialYears({ commit }) {
        await axios.get('/financialyears').then(res => {
            commit('setYears', res.data.years)
        })
    },
};
